import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import Button from '@mui/material/Button'
import ClearIcon from '@mui/icons-material/Clear'

import { axiosInstance } from '../../../hooks/useAxios'
import { ERRORS_MESSAGE_MAPPER } from '../../../constants/errors'
import {
  IProductGroup,
  IProductGroupMember,
} from '../../../types/product-group'
import CircularLoading from '../../../components/CircularProgress'
import ProductGroupMembersTable from './ProductGroupMembersTable'

type IProductGroupDetail = Omit<IProductGroup, 'products'> & {
  products: IProductGroupMember[]
}

interface IProductGroupViewModalProps {
  isOpen: boolean
  groupId?: string
  onClose: () => void
}

const ProductGroupViewModal = ({
  isOpen,
  groupId,
  onClose,
}: IProductGroupViewModalProps) => {
  const [group, setGroup] = useState<IProductGroupDetail>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!isOpen || !groupId) {
      return
    }
    setGroup(undefined)
    setIsLoading(true)
    axiosInstance
      .get<IProductGroupDetail>(`/product-group/${groupId}`)
      .then(({ data }) => setGroup(data))
      .catch((e) => {
        message.error(
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
            'โหลดข้อมูลไม่สำเร็จ',
        )
        onClose()
      })
      .finally(() => setIsLoading(false))
  }, [isOpen, groupId])

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {group
          ? `${group.name} (${group.products.length} รายการ)`
          : 'กลุ่มสินค้า'}
      </DialogTitle>
      <DialogContent>
        <CircularLoading isLoading={isLoading} />
        <ProductGroupMembersTable members={group?.products ?? []} />
        <Grid container mt={2} justifyContent="flex-end">
          <Button
            color="inherit"
            size="large"
            variant="contained"
            onClick={onClose}
            startIcon={<ClearIcon />}
          >
            ปิดหน้าต่าง
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ProductGroupViewModal
